// extracted by mini-css-extract-plugin
export default {"discountPrefix":"R9Nw2rmDv7ABCg0v3aEu"};